import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Terms() {
    useEffect(() => {
  window.scrollTo(0, 0);
}, []);
  const navigate = useNavigate();

  const section = (title, children) => (
    <div style={{ marginBottom: '2.5rem' }}>
      <h2 style={{ color: '#00D4AA', fontSize: '1.2rem', marginBottom: '1rem', borderBottom: '1px solid #1a2640', paddingBottom: '0.5rem' }}>
        {title}
      </h2>
      {children}
    </div>
  );

  const p = (text) => (
    <p style={{ color: '#8899aa', lineHeight: 1.8, marginBottom: '0.75rem', fontSize: '0.95rem' }}>{text}</p>
  );

  const li = (text) => (
    <li style={{ color: '#8899aa', lineHeight: 1.8, marginBottom: '0.4rem', fontSize: '0.95rem' }}>{text}</li>
  );

  return (
    <div style={{ background: '#0A0F1E', minHeight: '100vh', color: 'white', fontFamily: 'Arial, sans-serif', padding: '1.5rem', boxSizing: 'border-box' }}>

      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '3rem' }}>
        <span onClick={() => navigate('/')}
          style={{ color: '#00D4AA', fontWeight: 'bold', fontSize: '1.5rem', cursor: 'pointer' }}>
          CrackPrep
        </span>
        <button onClick={() => navigate(-1)}
          style={{ background: 'transparent', color: '#8899aa', border: '1px solid #1a2640', padding: '0.5rem 1rem', borderRadius: '6px', cursor: 'pointer' }}>
          ← Back
        </button>
      </div>

      <div style={{ maxWidth: '800px', margin: '0 auto' }}>

        <h1 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>Terms & Conditions</h1>
        <p style={{ color: '#8899aa', marginBottom: '3rem', fontSize: '0.9rem' }}>
          Last updated: May 2026 &nbsp;·&nbsp; Effective immediately upon use of the platform
        </p>

        {section('1. Acceptance of Terms',
          <>
            {p('By accessing or using CrackPrep ("the Platform", "we", "us"), you agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use the Platform.')}
            {p('CrackPrep is operated as an independent platform providing AI-powered resume analysis and interview preparation services. The platform is currently operated by an individual and is not incorporated as a legal entity.')}
          </>
        )}

        {section('2. Description of Service',
          <>
            {p('CrackPrep provides the following services:')}
            <ul style={{ paddingLeft: '1.5rem', marginBottom: '0.75rem' }}>
              {li('ATS (Applicant Tracking System) score analysis of your resume against a target job description')}
              {li('AI-generated resume improvement suggestions tailored to your target role')}
              {li('Personalised interview preparation material including competence, CV, and HR questions')}
              {li('Permanent storage of analysis history as per your purchased plan')}
            </ul>
            {p('All outputs are generated using Google Gemini AI and are intended as guidance only. CrackPrep does not guarantee employment outcomes, interview success, or job placement.')}
          </>
        )}

        {section('3. User Eligibility',
          <>
            {p('You must be at least 18 years of age to use CrackPrep. By using the Platform you confirm that you meet this requirement.')}
            {p('CrackPrep is currently available exclusively to users in India. International use is not supported at this time.')}
          </>
        )}

        {section('4. Account Registration',
          <>
            {p('You must create an account to use CrackPrep. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.')}
            {p('You agree to provide accurate and complete information during registration and to update it as necessary.')}
          </>
        )}

        {section('5. Pricing and Payments',
          <>
            {p('CrackPrep offers the following plans:')}
            <ul style={{ paddingLeft: '1.5rem', marginBottom: '0.75rem' }}>
              {li('Free: 1 complete analysis included at no cost for all new users')}
              {li('ResumePlus (₹99): 3 analyses — ATS score + full resume improvements')}
              {li('ResumePro (₹179): 7 analyses — ATS score + full resume improvements')}
              {li('InterviewPlus (₹249): 3 analyses — ATS score + full interview prep')}
              {li('InterviewPro (₹499): 7 analyses — ATS score + full interview prep')}
              {li('Elite (₹699): 7 analyses — ATS score + resume improvements + interview prep + up to 15 history')}
            </ul>
            {p('All plans are one-time payments. There are no recurring subscriptions unless explicitly stated.')}
            {p('When purchasing multiple plans of the same type, analysis credits stack (add up). History limits are set to the maximum of your two most recent plans of each type — they do not stack.')}
            {p('Payments are processed securely through Razorpay. CrackPrep does not store your payment card details.')}
          </>
        )}

        {section('6. Refund Policy',
          <>
            {p('All purchases on CrackPrep are final. We do not offer refunds once a plan has been purchased and analyses have been consumed.')}
            {p('If you experience a technical error that prevents you from using a purchased analysis, please contact us at support@crackprep.in within 48 hours of the incident and we will review your case on a discretionary basis.')}
          </>
        )}

        {section('7. Prohibited Use',
          <>
            {p('You agree not to:')}
            <ul style={{ paddingLeft: '1.5rem', marginBottom: '0.75rem' }}>
              {li('Share your account credentials with other users')}
              {li('Use a single account for multiple individuals')}
              {li('Resell, redistribute, or commercially exploit any content generated by CrackPrep')}
              {li('Attempt to reverse engineer, scrape, or copy the Platform or its AI outputs')}
              {li('Upload false, misleading, or malicious content to the Platform')}
              {li('Use the Platform for any unlawful purpose')}
            </ul>
            {p('Violation of these terms may result in immediate account suspension without refund.')}
          </>
        )}

        {section('8. Intellectual Property',
          <>
            {p('The CrackPrep platform, its design, and underlying technology are the intellectual property of CrackPrep. You may not reproduce or distribute any part of the Platform without written permission.')}
            {p('AI-generated outputs (ATS scores, resume suggestions, interview questions) are provided to you for personal use only. You retain ownership of the resume and job description content you upload.')}
          </>
        )}

        {section('9. PDF Downloads',
          <>
            {p('CrackPrep provides downloadable PDF reports for resume improvements and interview preparation material.')}
            {p('For the best experience when viewing downloaded PDFs, we recommend opening them with Adobe Acrobat Reader. PDFs may not render correctly in browser-based PDF viewers or other third-party applications.')}
            {p('Adobe Acrobat Reader is available as a free download at adobe.com/acrobat/pdf-reader.')}
          </>
        )}

        {section('10. Disclaimer of Warranties',
          <>
            {p('CrackPrep is provided "as is" without warranties of any kind. We do not guarantee that the Platform will be error-free, uninterrupted, or that AI-generated outputs will be accurate, complete, or suitable for your specific requirements.')}
            {p('AI outputs are generated by Google Gemini and may occasionally contain inaccuracies. Users should exercise their own judgement when applying suggestions to their resumes or interview preparation.')}
          </>
        )}

        {section('11. Limitation of Liability',
          <>
            {p('To the maximum extent permitted by applicable law, CrackPrep shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Platform, including but not limited to loss of employment opportunity, loss of income, or loss of data.')}
            {p('Our total liability to you for any claim arising from these Terms shall not exceed the amount you paid for the plan in question.')}
          </>
        )}

        {section('12. Data and Privacy',
          <>
            {p('Your use of CrackPrep is also governed by our Privacy Policy, which is incorporated into these Terms by reference. Please review our Privacy Policy to understand how we collect, use, and store your data.')}
          </>
        )}

        {section('13. Changes to Terms',
          <>
            {p('We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting to crackprep.in/terms. Continued use of the Platform after changes constitutes your acceptance of the updated Terms.')}
          </>
        )}

        {section('14. Governing Law',
          <>
            {p('These Terms are governed by and construed in accordance with the laws of India. Any disputes arising under these Terms shall be subject to the exclusive jurisdiction of the courts of India.')}
          </>
        )}

        {section('15. Contact',
          <>
            {p('For questions about these Terms, please contact us at:')}
            {p('Email: support@crackprep.in')}
            {p('Website: https://crackprep.in')}
          </>
        )}

      </div>
    </div>
  );
}